import {Component, ElementRef, Input, ViewChild} from '@angular/core';

import {SistemaService} from "../../Servicios/Sistema.Service";

import {ImagenCompletaComponent} from "./ImagenCompleta/ImagenCompleta.component";
import {App} from "../../app.component";
import { AlineacionImagenEnum } from '@componentes/Enums.enum';

@Component(
  {
    selector: 'imagenVisualizador',
    templateUrl: './ImagenVisualizador.template.html',
    styleUrls: ['./ImagenVisualizador.scss'],
  })

export class ImagenVisualizadorComponent
{
  @ViewChild('imagenDiv') imagenDiv! : ElementRef;
  @ViewChild('imagenElemento') imagenElemento! : ElementRef;
  @ViewChild('sinimagenElemento') sinimagenElemento! : ElementRef;

  @ViewChild('imagenCompleta') imagenCompleta! : ImagenCompletaComponent;

  @Input() imagen: string = ''; // la imagen
  @Input() verCompleta: boolean = true; // ver en grande la imagen
  @Input() alineacion : AlineacionImagenEnum = AlineacionImagenEnum.ScaleApectToFill; // la alineacion de la imagen
  @Input() sinImagenSRC : string = 'assets/sinImagenGeneral.png'; // ruta de la imagen por default que indica que no hay imagen
  @Input() sinImagen : boolean = false; // indica si no hay imagen
  @Input() imagenResponsiva : boolean = false; // indica si la imagen no tiene un tamaño fijo

  public AlineacionImagenEnum = AlineacionImagenEnum;
  public claseAlineacion : string = '';
  public id : number = 0;

  public altoDiv : number = 0;
  public anchoDiv : number = 0;

  public altoImagen : number = 0;
  public anchoImagen : number = 0;
  public cargada : boolean = false;

  private subscripcion: any = null;

  constructor(private  sistemaService : SistemaService, private app : App)
  {
    this.sistemaService.numeroControl++;
    this.id = this.sistemaService.numeroControl;
  }

  ngOnInit()
  {
    if (this.imagenResponsiva)
    {
      this.subscripcion = this.app.onResize.subscribe(
        (evento: any) =>
        {
          this.SetClaseAlineacion();
        }
      );
    }
  }

  ngOnDestroy()
  {
    if (this.subscripcion != null)
    {
      this.subscripcion.unsubscribe();
    }
  }

  ImagenCargada(imagen : any)
  {
    this.altoImagen = this.imagenElemento.nativeElement.height;
    this.anchoImagen = this.imagenElemento.nativeElement.width;

    setTimeout(() =>
    {
      this.SetClaseAlineacion();
       this.cargada = true;
    }, 0);
  }

  SinImagenCargada()
  {
    setTimeout(() =>
    {
      this.altoImagen = this.sinimagenElemento.nativeElement.height;
      this.anchoImagen = this.sinimagenElemento.nativeElement.width;

      // this.alineacion = AlineacionImagenEnum.ScaleApectToFill;

      setTimeout(() =>
      {
        this.SetClaseAlineacion();
        this.cargada = true;
      }, 0);
    });
  }

  SetClaseAlineacion()
  {
    switch (this.alineacion)
    {
      case AlineacionImagenEnum.ScaleToFill:
        this.claseAlineacion = "imageContainer__imagen--fill";
        break;


        /*if (this.altoImagen > this.anchoImagen)
        {
          this.claseAlineacion = "imageContainer__imagen--portrait";
        }
        else
        {
          this.claseAlineacion = "imageContainer__imagen--landscape";
        }
        break;*/

      case AlineacionImagenEnum.ScaleAspectToFit:
      case AlineacionImagenEnum.ScaleApectToFill:
      case AlineacionImagenEnum.Top:
      case AlineacionImagenEnum.Bottom:

        let element = document.getElementById("imagenDiv" + this.id);

        if (!element)
        {
          return;
        }

        let rect = element!.getBoundingClientRect();
        this.altoDiv = rect.height;
        this.anchoDiv = rect.width;

        let relacionImagen = this.anchoImagen / this.altoImagen;

        if (this.alineacion == AlineacionImagenEnum.ScaleAspectToFit)
        {
          if (this.altoImagen > this.anchoImagen)
          {
            let anchoImagen = this.altoDiv * relacionImagen;

            if (this.anchoDiv > anchoImagen)
            {
              this.claseAlineacion = "imageContainer__imagen--portrait";
            }
            else
            {
              this.claseAlineacion = "imageContainer__imagen--landscape";
            }
          }
          else
          {
            let altoImagen = this.anchoDiv * (1 / relacionImagen);

            if (this.altoDiv > altoImagen)
            {
              this.claseAlineacion = "imageContainer__imagen--landscape";
            }
            else
            {
              this.claseAlineacion = "imageContainer__imagen--portrait";
            }
          }
        }
        else
        {
          if (this.altoImagen > this.anchoImagen)
          {
            let anchoImagen = this.altoDiv * relacionImagen;

            if (this.anchoDiv > anchoImagen)
            {
              this.claseAlineacion = "imageContainer__imagen--landscape";
            }
            else
            {
              this.claseAlineacion = "imageContainer__imagen--portrait";
            }
          }
          else
          {
            let altoImagen = this.anchoDiv * (1 / relacionImagen);

            if (this.altoDiv > altoImagen)
            {
              this.claseAlineacion = "imageContainer__imagen--portrait";
            }
            else
            {
              this.claseAlineacion = "imageContainer__imagen--landscape";
            }
          }

          if (this.alineacion == AlineacionImagenEnum.Top)
          {
            this.claseAlineacion += " imageContainer__imagen--top";
          }
          else if (this.alineacion == AlineacionImagenEnum.Bottom)
          {
            this.claseAlineacion += " imageContainer__imagen--bottom";
          }
        }

        break;


      default:
        break;
    }
  }

  ErrorCarga()
  {
    this.sinImagen = true;
  }

  VerImagenCompleta()
  {
    if (this.verCompleta && !this.sinImagen)
    {
      this.imagenCompleta.AbrirImagen();
    }
  }
}
